<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "Employees"
};
</script>

<style></style>
